import Vue from 'vue'

// Renders a comment node. Used for
// clearing slot fallback content
// eslint-disable-next-line
Vue.component('void', {
  render: (h) => h(),
})
